// extracted by mini-css-extract-plugin
export default {"box":"EH20NM","profile":"QW3N4f"};